export default __webpack_public_path__ + "static/media/fiba.21618e3b.png";